export default function App() {
  return (
    <main className="relative flex min-h-dvh flex-col overflow-hidden px-6 py-10 sm:px-10">
      {/* Decorative only. */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div className="drift absolute top-1/3 left-1/2 h-[38rem] w-[38rem] rounded-full bg-[radial-gradient(circle,var(--color-accent)_0%,transparent_62%)] opacity-[0.16] blur-3xl" />
        <div className="absolute inset-0 bg-[linear-gradient(to_bottom,transparent,var(--color-ink)_78%)]" />
      </div>

      <header className="flex items-center gap-2.5">
        <span
          aria-hidden
          className="h-2.5 w-2.5 rounded-full bg-[var(--color-accent)] shadow-[0_0_18px_var(--color-accent)]"
        />
        <span className="font-mono text-sm tracking-[0.22em] text-[var(--color-fg-muted)] uppercase">
          Orus&nbsp;AI
        </span>
      </header>

      <div className="flex flex-1 items-center">
        <div className="mx-auto w-full max-w-2xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-[var(--color-line)] bg-[var(--color-ink-soft)]/70 px-3.5 py-1.5 font-mono text-[0.7rem] tracking-[0.16em] text-[var(--color-fg-muted)] uppercase">
            <span
              aria-hidden
              className="h-1.5 w-1.5 rounded-full bg-amber-400 shadow-[0_0_10px] shadow-amber-400/70"
            />
            Under development
          </p>

          <h1 className="mt-7 text-4xl leading-[1.08] font-medium tracking-tight text-balance sm:text-6xl">
            Interpretable machine learning for portfolio construction.
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-pretty text-[var(--color-fg-muted)] sm:text-lg">
            We are building models whose allocations can be explained, not just
            backtested — sparse, long-only portfolios with the reasoning left intact.
            This site is being written now; there is nothing to see here yet.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3">
            <a
              href="mailto:nne@nepintel.com"
              className="rounded-md bg-[var(--color-accent)] px-4 py-2.5 text-sm font-medium text-[var(--color-ink)] transition-opacity hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-accent)]"
            >
              Get in touch
            </a>
            <span className="font-mono text-xs text-[var(--color-fg-muted)]">orusai.be</span>
          </div>
        </div>
      </div>

      <footer className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-[var(--color-line)] pt-5 font-mono text-[0.7rem] text-[var(--color-fg-muted)]">
        <span>© {new Date().getFullYear()} Orus AI</span>
        <span>Belgium</span>
      </footer>
    </main>
  );
}
